import { PackageSearchIcon } from 'lucide-react';
import { cn } from 'lib/utils';

type Props = {
  status: string;
}

export const StatusIndicator = ({ status }: Props) => {
  return (
    <div className={cn(
      'w-5 h-5 rounded-full bg-gray-600 text-white',
      'flex items-center justify-center',
      status === 'fila' && 'bg-blue-500',
      status === 'producao' && 'bg-yellow-500',
      status === 'finalizado' && 'bg-green-500',
      status === 'cancelado' && 'bg-red-500',
    )}>
      <PackageSearchIcon className={'w-4 h-4'} />
    </div>
  );
};